import { uniqueId as _uniqueId } from 'lodash-es';
import React, { useState } from 'react';

import { ITestProps } from '../../utils/dataTest';

import { TabContent } from '../Tab.Content';

import styles from './Tab.Group.module.scss';
export interface ITabGroupProps extends ITestProps {
  as?: 'nav' | 'tablist';
  /** This number indicates which tab is active and sets the state in Tab.Group */
  activeTabIndex?: number;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  /** Adds a CSS class to the content container <div> element */
  contentClassName?: string;
  /** Adds a CSS class <button> element of the tab */
  tabClassName?: string;
  /** Private: Callback function for the tab group */
  onTabIndexChanged?(tabIndexClicked): void;
}

export const TabGroup: React.FC<ITabGroupProps> = (props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(props.activeTabIndex);
  const [id] = useState(_uniqueId('tabPanel-'));

  const onTabClicked = (tabIndexClicked) => {
    setActiveTabIndex(tabIndexClicked);
    if (props.onTabIndexChanged) {
      props.onTabIndexChanged(tabIndexClicked);
    }
  };

  return (
    <div>
      <div
        aria-label={props.ariaLabel}
        aria-labelledby={props.ariaLabelledBy}
        role={props.as === 'nav' ? 'navigation' : 'tablist'}
        data-test={props.dataTest}
        className={styles.tabGroupContainer}
      >
        {React.Children.map(props.children, (child, index) =>
          child
            ? React.cloneElement(child as any, {
                activeTabIndex: activeTabIndex,
                ariaControls: id,
                className: props.tabClassName,
                key: index,
                index,
                numTabsInGroup: React.Children.count(props.children),
                onTabClicked: () => onTabClicked(index)
              })
            : null
        )}
        <div className={styles.tabNavShadowContainer}>
          <div className={styles.tabNavShadow} />
        </div>
      </div>
      {React.Children.map(props.children, (child, index) => {
        const childRef = child as any;
        if (childRef && childRef.props.children !== '') {
          return (
            <TabContent className={props.contentClassName} id={id} active={activeTabIndex === index}>
              {childRef.props.children}
            </TabContent>
          );
        }
      })}
    </div>
  );
};
